module.exports = __webpack_public_path__ + "img/back_kick_pleat_length.7b2e00a9.png";